<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-date-picker
                        range
                        :range-inline="false"
                        start-label="Período de"
                        end-label="Até"
                        v-model="data.model.periodo"
                        :min-date="data.additionals.periodoMinDate"
                        :max-date="data.additionals.currentDate"
                        :start-validations="validations.periodo.start"
                        :end-validations="validations.periodo.end"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-date-picker
                        label="Data de nascimento"
                        v-model="data.model.dataNascimento"
                        :max-date="data.additionals.currentDate"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Prontuário"
                        v-model="data.model.prontuario"
                        number
                    />
                </rkm-col>
                <rkm-col cols="3">
                    <rkm-form-input
                        label="Agendamento"
                        v-model="data.model.atendimento"
                        number
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        label="Paciente"
                        v-model="data.model.paciente"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click="$refs.Form.validate(search)"
                    >
                        Buscar
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="resetForm()"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            :items="agendamentos"
            :fields="fields.tables.atendimentos"
            hide-filters
        >
            <template v-slot:cell(pacienteNome)="row">
                <rkm-button
                    class="mr-2"
                    color="secondary"
                    small
                    v-rkm-popover.hover.right="
                        {
                            title: 'Dados cadastrais',
                            html: true,
                            content:
                                '<b>Prontuário:</b> ' + (row.item.prontuario || '') + '<br/>' +
                                '<b>Data de Nascimento:</b> ' + row.item.dataNascimento + '<br/>' +
                                '<b>Nome da Mãe:</b> ' + row.item.nomeMae + '<br/>' +
                                '<b>Unidade Solicitante:</b> ' + row.item.unidadeSolicitanteNome + '<br/>'
                        }
                    "
                >
                    <rkm-icon icon="user" />
                </rkm-button>

                <span v-if="!row.item.sequencialDesconhecido">
                    {{row.item.pacienteNome}}
                </span>

                <span
                    v-else
                    class="text-primary"
                    v-rkm-popover.hover.top="
                        {
                            title: 'Características físicas',
                            content: row.item.caracteristicasFisicas
                        }
                    "
                >
                    {{row.item.pacienteNome}}
                </span>
            </template>

            <template v-slot:cell(horaExame)="row">
                {{row.item.horaExame}}
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    color="primary"
                    small
                    title="Imprimir"
                    @click="$refs.ModalImpressao.open(item.impressoes, item.atendimentoId)"
                >
                    <rkm-icon icon="print" />
                </rkm-button>
            </template>
        </rkm-table>

        <ModalImpressao ref="ModalImpressao" />
    </div>
</template>

<script>
import ModalImpressao from './components/impressao/Modal'

import { mapActions } from 'vuex'
import { repository, error, object, data, stringCase } from '@/mixins'

export default {
    components: { ModalImpressao },
    computed: {
        fields() {

            return {
                tables: {
                    atendimentos: [
                        { key: 'data', label: 'Data', searchable: true, sortable: true},
                        { name: 'prontuario', key: 'prontuario', label: 'Prontuário', searchable: true, sortable: true },
                        { name: 'agendamentoNumero', key: 'agendamentoNumero',   label: 'Agendamento', searchable: true, sortable: true },
                        { name: 'pacienteNome', key: 'pacienteNome', label: 'Paciente', searchable: true, sortable: true },
                        { name: 'horaExame', key: 'horaExame', label: 'Horário agendado', searchable: true, sortable: true },
                        { name: 'nomeFantasia', key: 'nomeFantasia', label: 'Unidade agendada', searchable: true, sortable: true },
                        { name: 'profissionalNome', key: 'profissionalNome', label: 'Profissional agendado', searchable: true, sortable: true },
                        { key: 'actions', label: 'Ações', class: 'col-min text-center' },
                    ]
                }
            }
        },
        validations() {

            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                }
            }
        }
    },
    created() {

        this.repositories = {
            impressao: this.getConectaSusRepository('exameImagem.impressao')
        }
    },
    data: () => ({
        agendamentos: []
    }),
    mixins: [repository, error, object, data, stringCase],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        search() {

            this.setLoading()

            this.repositories.impressao.datatable(this.getSearchParams())
                .then(({ data }) => {

                    this.agendamentos = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getSearchParams() {

            const params = this.clone(this.data.model)

            this.formateDates(params.periodo, ['start', 'end'], 'DD/MM/YYYY')
            this.formateDates(params, ['dataNascimento'], 'DD/MM/YYYY')

            return this.camelObjectKeysToSnakeRecursive(params)
        },
        resetForm() {

            this.data.model.periodo.start = this.clone(this.data.initials.model.periodo.start)
            this.data.model.periodo.end = this.clone(this.data.initials.model.periodo.end)
            this.data.model.paciente = this.data.initials.model.paciente
            this.data.model.dataNascimento = this.clone(this.data.initials.model.dataNascimento)
            this.data.model.atendimento = this.data.initials.model.atendimento
            this.data.model.prontuario = this.data.initials.model.prontuario

            this.$nextTick(() => this.$refs.Form.resetValidator())
        }
    },
    props: {
        data: { type: Object, required: true }
    }
}
</script>